const t = "_active_1s3c7_48", e = {
  "top-bar": "_top-bar_1s3c7_1",
  "top-bar--items": "_top-bar--items_1s3c7_20",
  "top-bar--items--item": "_top-bar--items--item_1s3c7_27",
  active: t,
  "top-bar--items--item-label": "_top-bar--items--item-label_1s3c7_51"
};
export {
  t as active,
  e as default
};
